import { HStack } from '@chakra-ui/react';

import { RoundedBadge } from '.';
import { CompanyStatus } from '../models';
import { AnyFormatToString, pascalCaseToString } from '../utils';

export function FilterBadges<T extends Object>({
  filters,
  onRemoveFilter,
  filterMapper,
}: {
  filters: T;
  onRemoveFilter: (filter: keyof typeof filters) => void;
  filterMapper?: { value: string; text: string }[];
}) {
  return Object.entries(filters).map(([key, value]) => {
    if (value)
      return (
        <HStack key={key}>
          <RoundedBadge
            colorSchema={CompanyStatus.ACTIVE}
            withCloseButton
            onClose={() => onRemoveFilter(key as keyof typeof filters)}
          >
            {pascalCaseToString(key.split('ID')[0])}:{' '}
            {Array.isArray(filterMapper) && filterMapper.length
              ? filterMapper?.find(
                  filter => String(filter.value) === String(value)
                )?.text
              : value && AnyFormatToString(value as string)}
          </RoundedBadge>
        </HStack>
      );
  });
}
